export enum RatesPath {
  id = "id",
}

export interface PathParams {
  [RatesPath.id]: string;
}
